import { api } from '../../../../app/auth/apiSlice';
import {
  MenuItemProps,
  MenuProps,
  SubMenuItemProps,
  SubMenuProps,
} from '../../../template/SideNav/sideNavSlice';
import { SortItem } from '../../News-carousel/store/newsSlice';

interface FavoriteMenuItemProps {
  id: string | number;
  menu_item_id: string | number;
  submenu_item: SubMenuItemProps[];
}

const MenuApi = api
  .enhanceEndpoints({
    addTagTypes: ['AdminSideNavMenu', 'SideNavMenu', 'FavoritesMenu'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      // front end menus
      getSideNavMenus: builder.query<MenuItemProps[], void>({
        query: () => {
          return `v1/web-contents/menus/1/`;
        },
        providesTags: ['SideNavMenu'],
      }),

      getMenuAll: builder.query<MenuProps, void>({
        query: () => {
          return `v1/web-contents/menu-items/?limit=1000`;
        },
        providesTags: ['AdminSideNavMenu'],
      }),
      getSubMenuAll: builder.query<SubMenuProps, void>({
        query: () => {
          return `v1/web-contents/sub-menu-items/?limit=1000`;
        },
        providesTags: ['AdminSideNavMenu'],
      }),
      sortMenu: builder.mutation({
        query: (arg: SortItem) => ({
          url: `v1/web-contents/menu-items/sort`,
          method: 'PATCH',
          body: arg,
        }),
        invalidatesTags: ['SideNavMenu', 'AdminSideNavMenu'],
      }),
      sortSubMenu: builder.mutation({
        query: (arg: SortItem) => ({
          url: `v1/web-contents/sub-menu-items/sort`,
          method: 'PATCH',
          body: arg,
        }),
        invalidatesTags: ['SideNavMenu', 'AdminSideNavMenu'],
      }),
      getMenuById: builder.query<
        MenuItemProps,
        { id: string | number | undefined }
      >({
        query: ({ id }) => {
          return `v1/web-contents/menu-items/${id}`;
        },
        providesTags: ['AdminSideNavMenu'],
      }),
      getSubMenuById: builder.query<
        SubMenuItemProps,
        { id: string | number | undefined }
      >({
        query: ({ id }) => {
          return `v1/web-contents/sub-menu-items/${id}`;
        },
        providesTags: ['AdminSideNavMenu'],
      }),
      updateMenu: builder.mutation<
        MenuItemProps,
        { id: string | number; news: MenuItemProps }
      >({
        query: ({ id, news }) => ({
          url: `v1/web-contents/menu-items/${id}`,
          method: 'PATCH',
          body: news,
        }),
        invalidatesTags: ['SideNavMenu', 'AdminSideNavMenu'],
      }),
      updateSubMenu: builder.mutation<
        SubMenuItemProps,
        { id: string | number; submenu: SubMenuItemProps }
      >({
        query: ({ id, submenu }) => ({
          url: `v1/web-contents/sub-menu-items/${id}`,
          method: 'PATCH',
          body: submenu,
        }),
        invalidatesTags: ['SideNavMenu', 'AdminSideNavMenu'],
      }),
      addMenu: builder.mutation({
        query: (arg: MenuItemProps) => ({
          url: `v1/web-contents/menu-items/`,
          method: 'POST',
          body: arg,
        }),
        invalidatesTags: ['SideNavMenu', 'AdminSideNavMenu'],
      }),
      addSubMenu: builder.mutation({
        query: (arg: SubMenuItemProps) => ({
          url: `v1/web-contents/sub-menu-items/`,
          method: 'POST',
          body: arg,
        }),
        invalidatesTags: ['SideNavMenu', 'AdminSideNavMenu'],
      }),
      deleteMenu: builder.mutation({
        query: (id) => ({
          url: `v1/web-contents/menu-items/${id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['SideNavMenu', 'AdminSideNavMenu'],
      }),
      deleteSubMenu: builder.mutation({
        query: (id) => ({
          url: `v1/web-contents/sub-menu-items/${id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['SideNavMenu', 'AdminSideNavMenu'],
      }),

      getSideNavFavoritesMenus: builder.query<FavoriteMenuItemProps[], void>({
        query: () => {
          return `v1/web-contents/favorites/`;
        },
        providesTags: ['FavoritesMenu'],
      }),

      addFavoriteList: builder.mutation({
        query: (arg: {
          submenu_item: string | number;
          user: string | number;
        }) => ({
          url: `v1/web-contents/favorites/`,
          method: 'POST',
          body: arg,
        }),
        invalidatesTags: ['FavoritesMenu'],
      }),

      deleteFavoriteList: builder.mutation({
        query: (id) => ({
          url: `v1/web-contents/favorites/submenu-item/${id}/`,
          method: 'DELETE',
        }),
        invalidatesTags: ['FavoritesMenu'],
      }),
    }),
  });

export const {
  useGetMenuAllQuery,
  useSortMenuMutation,
  useSortSubMenuMutation,
  useGetMenuByIdQuery,
  useUpdateMenuMutation,
  useAddMenuMutation,
  useDeleteMenuMutation,
  useGetSubMenuAllQuery,
  useGetSubMenuByIdQuery,
  useUpdateSubMenuMutation,
  useAddSubMenuMutation,
  useDeleteSubMenuMutation,
  useGetSideNavMenusQuery,
  useGetSideNavFavoritesMenusQuery,
  useAddFavoriteListMutation,
  useDeleteFavoriteListMutation,
} = MenuApi;
